import { useEffect } from "react";
import { useLocation } from "react-router";

const ScrollToTop = ({ children, extraTrigger }) => { 
    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
  }, [location, extraTrigger]);

    return <>{children}</>
};

export default ScrollToTop;